import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter
} from "@angular/core";

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.css']
})
export class CaptchaComponent implements OnChanges {
  @Input("config") config: any = {};
  @Output() captchaCode = new EventEmitter();
  captch_input: any = null;
  code: any = null;
  resultCode: any = null;
  constructor() {
    
   }
  ngOnChanges() {
    if (this.config) {
      if (!this.config.font || !this.config.font.size) {
        this.config["font"]["size"] = "40px";
      }
      if (!this.config.font || !this.config.font.family) {
        this.config["font"]["family"] = "Arial";
      }
      if (!this.config.strokeColor) {
        this.config["strokeColor"] = "#f20c6c";
      }
      if (!this.config.length) {
        this.config["length"] = 6;
      }
      if (!this.config.cssClass) {
        this.config["cssClass"] = '';
      }

      if (!this.config.type) {
        this.config["type"] = 1;
      }

      if (!this.config.back || !this.config.back.stroke) {
        this.config["back"]["stroke"] = "";
      }
      if (!this.config.back || !this.config.back.solid) {
        this.config["back"]["solid"] = "#f2efd2";
      }

      this.createCaptcha();
    }
  }
  createCaptcha() {

    switch (this.config.type) {
      case 1: // only alpha numaric degits to type
        let char = this.generateCaptchaCode(this.config.length)
        this.code = this.resultCode = char;
        break;
      case 2: // solve the calculation 
        let num1 = Math.floor(Math.random() * 99);
        let num2 = Math.floor(Math.random() * 9);
        let operators = ['+', '-'];
        let operator = operators[(Math.floor(Math.random() * operators.length))];
        this.code = num1 + operator + num2 + '=?';
        this.resultCode = (operator == '+') ? (num1 + num2) : (num1 - num2);
        break;
    }


    setTimeout(() => {
      let captcahCanvas: any = document.getElementById("captcahCanvas");
      var ctx = captcahCanvas.getContext("2d");
      ctx.fillStyle = this.config.back.solid;
      ctx.fillRect(0, 0, captcahCanvas.width, captcahCanvas.height);

      ctx.beginPath();

      //captcahCanvas.style.letterSpacing = 15 + "px";
      ctx.font = this.config.font.size + " " + this.config.font.family;
      ctx.fillStyle = this.config.font.color;
      ctx.textBaseline = "middle";
      let codeStr = this.code.toString().split('').join('  ')
      ctx.fillText(codeStr, 15, 25);
      if (this.config.back.stroke) {
        ctx.strokeStyle = this.config.back.stroke;
        for (var i = 0; i < 100; i++) {
          ctx.moveTo(Math.random() * 200, Math.random() * 200);
          ctx.lineTo(Math.random() * 200, Math.random() * 200);
        }
        ctx.stroke();
      }
      this.captchaCode.emit(this.resultCode)
    }, 100);
  }

  // checkCaptcha() {
  //   if (this.captch_input != this.resultCode) {
  //     this.captchaCode.emit(false)
  //   } else {
  //     this.captchaCode.emit(true)
  //   }
  // }

  generateCaptchaCode(length = 6) {
    let numeric = '1234567890';
    let upperCase = 'NRQGDBAHJUTE';
    let lowerCase = 'abcdefghjkmnopqrstuvwxyz';
    let specialChar = '@#=$%^&';
    let code = '';
    for (let i = 0; i < length; i++) {
      if(i == 0) {
        code += numeric.charAt(Math.floor(Math.random() * numeric.length));
      }
      if(i == 1 || i == 2){
        code += upperCase.charAt(Math.floor(Math.random() * upperCase.length));
      }
      if(i == 3 || i == 4){
        code += lowerCase.charAt(Math.floor(Math.random() * lowerCase.length));
      }
      if(i == 0) {
        code += specialChar.charAt(Math.floor(Math.random() * specialChar.length));
      }
    }
    return this.shuffle(code.split(""));
  }

  shuffle(array) {
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex != 0) {

      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }

    return array.join("");
  }
}